import { addressToString } from '../../../common/utils/address';

export const isRemoteUrl = url => typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'));
export const getPhotoId = photo => photo?.id || photo?._id || photo;
const hasPhotos = item => Boolean(item?.visualDirectionPhotos?.length || item?.visualDirectionPhotoUrls?.length);
export const hasDirectionsContent = item => Boolean(item?.directions || hasPhotos(item));
export const hasMapDetails = location => Boolean(location?.coordinates?.length || addressToString(location?.addressObj));
